import { render, staticRenderFns } from "./ComplaintFinishView.vue?vue&type=template&id=19611608&"
import script from "./ComplaintFinishView.vue?vue&type=script&lang=js&"
export * from "./ComplaintFinishView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports